import React from "react";

const Skeleton = () => {
	return (
		<li className="skeleton">
			<div className="pulse header"></div>
			<div className="pulse image"></div>
			<div className="pulse info"></div>
		</li>
	);
};

export default Skeleton;
